/* sb-dc-tplbutton.js — a way back to the templates page from the editor.
   2026-09-04, updated 2026-09-05.

   Once the editor is open there is no obvious route to the template gallery:
   the only link is tucked inside the logo block. A customer who came from a
   product page and now wants a design has to know to go back in the browser.
   This puts "See All Design Templates" in the header, right after Shortcuts,
   styled from the neighbouring button so it matches whatever the theme does.

   2026-09-05: it opens the same product picker the top bar uses
   (sb-tpl-picker.js), rather than jumping straight to the current product's
   templates. Someone in the editor is often deciding what to make, not just
   how to decorate what they already chose — and the picker still gets them to
   a filtered gallery in one more click.

   The wording is longer than the top bar's "Design Templates" on purpose: in
   the editor the customer already has a design on screen, so the button has to
   say it leads somewhere else rather than reading as a label for what they are
   looking at.

   Whatever they pick opens in a new tab: the editor keeps nothing, so a stray
   click must never cost them the design in progress.

   If the picker file is missing for any reason, the button falls back to a
   plain link — filtered to the product being designed, which was the old
   behaviour. The header is React's and repaints, so the button is re-inserted
   on a timer rather than added once. */
(function () {
  'use strict';

  var ID = 'sbdc-tpl-btn';
  var BASE = '/pages/design-templates';
  var LABEL = 'See All Design Templates';

  function shortcutsBtn() {
    var bs = document.querySelectorAll('button');
    for (var i = 0; i < bs.length; i++) {
      if (/^shortcuts/i.test((bs[i].textContent || '').trim())) return bs[i];
    }
    return null;
  }

  function handle() {
    try {
      var p = window.__dcAppliedProduct && window.__dcAppliedProduct();
      return (p && p.handle) || null;
    } catch (e) { return null; }
  }

  function fallbackHref() {
    var h = handle();
    return h ? BASE + '?for=' + encodeURIComponent(h) : BASE;
  }

  function place() {
    var a = document.getElementById(ID);
    var ref = shortcutsBtn();
    if (!ref || !ref.parentNode) return;

    if (!a) {
      a = document.createElement('a');
      a.id = ID;
      a.target = '_blank';
      a.rel = 'noopener';
      /* Borrow the neighbour's classes so it inherits the header's button look
         instead of us guessing at colours that would drift from the theme. */
      a.className = ref.className;
      a.style.textDecoration = 'none';
      a.style.display = 'inline-flex';
      a.style.alignItems = 'center';
      a.addEventListener('click', function (e) {
        var picker = window.__sbTplPicker;
        if (picker && typeof picker.show === 'function') {
          e.preventDefault();
          picker.show();
        }
        /* No picker on the page: let the href do its job. */
      });
      ref.parentNode.insertBefore(a, ref.nextSibling);
    }

    /* Set on every pass: the header re-renders and can reset the text. */
    if (a.textContent !== LABEL) a.textContent = LABEL;

    /* Keep the fallback link pointed at whatever is being designed now, since
       the product can change while the editor is open. */
    var want = fallbackHref();
    if (a.getAttribute('href') !== want) a.setAttribute('href', want);
  }

  var t = setInterval(function () { try { place(); } catch (e) {} }, 400);
  window.addEventListener('pagehide', function () { clearInterval(t); });
})();
